import { LoaderIcon } from 'lucide-react';
import { ReactNode } from 'react';
import { PageBreadcrumb, PageBreadcrumbProps } from '@/components/page-breadcrumb.js';
import { TabPage, TabPageDefinition } from './tab-pages.js';

interface InfoPageProps {
  children: ReactNode;
  headerActions?: ReactNode;
  headerText: string | ReactNode;
  loading?: boolean;
  breadcrumbs?: PageBreadcrumbProps;
  tabs?: TabPageDefinition[];
  showRedDot?: boolean;
  'data-testid'?: string;
}

export const InfoPage = ({
  children,
  headerText,
  headerActions,
  loading,
  breadcrumbs,
  tabs,
  showRedDot = true,
  'data-testid': dataTestId,
}: InfoPageProps) => {
  return (
    <>
      {breadcrumbs && (
        <div className="p-4">
          <PageBreadcrumb
            {...breadcrumbs}
            data-testid={dataTestId ? `${dataTestId}-breadcrumb` : 'info-page-breadcrumb'}
          />
        </div>
      )}
      <div className="flex justify-between gap-4 md:px-4 py-4 md:pt-4 md:pb-1">
        <div className="flex items-center">
          {showRedDot && <div className="bg-[#EB404A] w-[6px] h-[24px] mr-2" />}
          <h2 className="items-center flex font-bold text-2xl" data-testid={dataTestId || 'info-page-header'}>
            {headerText}
          </h2>
        </div>
        <div className="flex items-center justify-end gap-x-2 self-start">{headerActions}</div>
      </div>
      {loading ? (
        <div className="grid place-content-center w-full h-full">
          <LoaderIcon />
        </div>
      ) : (
        <div className="w-full md:p-4 min-h-0 flex flex-1 flex-col">
          {tabs && <TabPage tabs={tabs}>{children}</TabPage>}
          {!tabs && <>{children}</>}
        </div>
      )}
    </>
  );
};
